/**
 * @generated SignedSource<<7478b7f6f49ae8da025e636dd01fc6ad>>
 * @relayHash a7fc4e9c382896a4769627413accc3ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c9a641f91a8624f90047b210e0dc40067db21c90ddcca76f463db856927c1088

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraLongRunningTaskStatus = "CANCELLED" | "CANCEL_REQUESTED" | "COMPLETE" | "DEAD" | "ENQUEUED" | "FAILED" | "RUNNING" | "%future added value";
export type IssueHierarchyViewQuery$variables = {
  cloudId: string;
};
export type IssueHierarchyViewQuery$data = {
  readonly jira: {
    readonly issueHierarchyConfig: {
      readonly data: ReadonlyArray<{
        readonly cmpIssueTypes: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly avatar: {
                readonly small: string | null | undefined;
              } | null | undefined;
              readonly description: string | null | undefined;
              readonly hierarchy: {
                readonly level: number | null | undefined;
              } | null | undefined;
              readonly id: string;
              readonly issueTypeId: string | null | undefined;
              readonly name: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly hierarchyLevel: {
          readonly level: number | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
      }> | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly code: string | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
    readonly issueHierarchyConfigUpdateTask: {
      readonly errors: ReadonlyArray<{
        readonly code: string | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly issueHierarchyConfig: ReadonlyArray<{
        readonly cmpIssueTypes: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly avatar: {
                readonly small: string | null | undefined;
              } | null | undefined;
              readonly description: string | null | undefined;
              readonly hierarchy: {
                readonly level: number | null | undefined;
              } | null | undefined;
              readonly id: string;
              readonly issueTypeId: string | null | undefined;
              readonly name: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly hierarchyLevel: {
          readonly level: number | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
      }> | null | undefined;
      readonly taskProgress: {
        readonly progress: AGG$Long;
        readonly status: JiraLongRunningTaskStatus;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"SaveButtonSaveButton" | "SaveDialog">;
    } | null | undefined;
    readonly issueHierarchyLimits: {
      readonly maxLevels: number;
      readonly nameLength: number;
    } | null | undefined;
    readonly lockedIssueTypeIds: ReadonlyArray<string> | null | undefined;
  } | null | undefined;
};
export type IssueHierarchyViewQuery = {
  response: IssueHierarchyViewQuery$data;
  variables: IssueHierarchyViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "level"
},
v4 = [
  {
    "concreteType": "JiraIssueTypeHierarchyLevel",
    "kind": "LinkedField",
    "name": "hierarchyLevel",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/)
    ]
  },
  {
    "concreteType": "JiraIssueTypeConnection",
    "kind": "LinkedField",
    "name": "cmpIssueTypes",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraIssueTypeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "issueTypeId"
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "concreteType": "JiraIssueTypeHierarchyLevel",
                "kind": "LinkedField",
                "name": "hierarchy",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              },
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "small"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v5 = {
  "concreteType": "JiraHierarchyConfigError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "code"
    },
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v6 = {
  "args": (v1/*: any*/),
  "concreteType": "JiraIssueHierarchyConfigurationQuery",
  "kind": "LinkedField",
  "name": "issueHierarchyConfig",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueHierarchyConfigData",
      "kind": "LinkedField",
      "name": "data",
      "plural": true,
      "selections": (v4/*: any*/)
    },
    {
      "kind": "ScalarField",
      "name": "success"
    },
    (v5/*: any*/)
  ]
},
v7 = {
  "args": (v1/*: any*/),
  "concreteType": "JiraIssueHierarchyLimits",
  "kind": "LinkedField",
  "name": "issueHierarchyLimits",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "maxLevels"
    },
    {
      "kind": "ScalarField",
      "name": "nameLength"
    }
  ]
},
v8 = {
  "args": (v1/*: any*/),
  "kind": "ScalarField",
  "name": "lockedIssueTypeIds"
},
v9 = {
  "concreteType": "JiraIssueHierarchyConfigData",
  "kind": "LinkedField",
  "name": "issueHierarchyConfig",
  "plural": true,
  "selections": (v4/*: any*/)
},
v10 = {
  "concreteType": "JiraLongRunningTaskProgress",
  "kind": "LinkedField",
  "name": "taskProgress",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "progress"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "IssueHierarchyViewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraHierarchyConfigTask",
            "kind": "LinkedField",
            "name": "issueHierarchyConfigUpdateTask",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "SaveButtonSaveButton"
              },
              {
                "kind": "FragmentSpread",
                "name": "SaveDialog"
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueHierarchyViewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraHierarchyConfigTask",
            "kind": "LinkedField",
            "name": "issueHierarchyConfigUpdateTask",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c9a641f91a8624f90047b210e0dc40067db21c90ddcca76f463db856927c1088",
    "metadata": {},
    "name": "IssueHierarchyViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "01d8ce6b2a99e8bb6f021090db170c86";

export default node;
